import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Tooltip } from 'react-tooltip';

const ZohoBooks = () => {
  const urlParam = new URLSearchParams(window.location.hash.substring(1));
  const cancelSessionId = urlParam.get('cancelSessionId');
  
  if (cancelSessionId) {
    alert("Your payment was canceled. Please try again.");
    window.history.replaceState(null, null, window.location.pathname);
  }
  
  
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  console.log("Sfsdfsdf", process.env.REACT_APP_STRIPE_PUBLIC_KEY)
  
  const handleCheckout = async (plan, price, years, attachments) => {
    const stripe = await stripePromise;
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/checkout-session-book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ plan, price, years, attachments }),
      });
      console.log(response)
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
  
      const { sessionId } = await response.json();
      console.log("Session ID received from backend:", sessionId);

      const { error } = await stripe.redirectToCheckout({ sessionId });
  
      if (error) {
      
        console.log(error)
      }
    } catch (error) {
      console.log(error)
     
    }
  };
  
  const handleCheckoutButton = (index) => {
    if (formData[index].years === 0) {
      return;
    }
    const { years, attachments } = formData[index];
    const selectedPlan = index === 0 ? 'Essential' : 'Advanced';
    const price = prices[index];
  
    handleCheckout(selectedPlan, price, years, attachments);
  };
  
  useEffect(() => {
    formData.forEach((data, index) => {
      calculatePrice(data.years, data.attachments, index);
    });
  }, []);
  
  const [formData, setFormData] = useState([
    { years: 1, attachments: 0 },
    { years: 1, attachments: 0 },
  ]);
  const [prices, setPrices] = useState([0, 0]);
  
  const calculatePrice = (years, attachments, index) => {
    let base_price = index === 0 ? 999 : 1499;
    let additional_year_cost = 0;

    if (years > 1) {
      if (index === 0) {
        additional_year_cost = (years - 1) * 350;
      } else {
        const extraYears = years - 1;
        const tierOneYears = Math.min(extraYears, 3);
        const tierTwoYears = Math.max(extraYears - 3, 0);
        additional_year_cost = tierOneYears * 500 + tierTwoYears * 400;
      }
    }

    let attachment_cost = attachments > 0 ? Math.max(attachments * 0.5, 100) : 0;
  
    const totalPrice = base_price + additional_year_cost + attachment_cost;
  
    setPrices((prevPrices) => {
      const updatedPrices = [...prevPrices];
      updatedPrices[index] = totalPrice;
      return updatedPrices;
    });
  };
  
  const handleInputChange = (field, value, index) => {
    setFormData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = { ...updatedData[index], [field]: value };
      calculatePrice(updatedData[index].years, updatedData[index].attachments, index);
      return updatedData;
    });
  };
  
  const plans = [
    {
      title: 'Essential',
      price: `${prices[0].toFixed(0)}`,
      features: [
        'Basic Zoho Books Setup',
        'Non-Financial Data Transfer',
        'Financial Data Transfer',
        'Detailed Transaction Mapping',
        'Tax Migration',
        'Reconciliations',
        'Data Integrity Assurance',
        'Enhanced Data Security',
        'Basic Support',
      ],
      tooltips: [
        'Basic configuration of Zoho Books includes setting up essential features and functionalities to match the clients current operational needs.',
        'Migration of essential non-financial data such as customers, vendors, and products/services.',
        'Transfer of core financial data like invoices, bills, and journal entries.',
        'Mapping of discounts, payments, and credits to the correct transactions.',
        'Migration of tax-related data including input/output taxes, agencies, and tax types.',
        'Accurate reconciliation of accounts, customer, and vendor balances.',
        'Ensuring all migrated data matches the financial statements from QuickBooks.',
        'Strong security measures ensuring data integrity and confidentiality during migration.',
        'One month of specialized post-migration assistance for a smooth transition.',
      ]
    },
    {
      title: 'Advanced',
      price: `${prices[1].toFixed(2)}`,
      features: [
        'Advanced Zoho Books Setup',
        'Non-Financial Data Transfer',
        'Financial Data Transfer',
        'Advanced Inventory Migration',
        'Multi-Currency Handling',
        'Projects',
        'Detailed Transaction Mapping',
        'Tax Migration',
        'Reconciliations',
        'Data Integrity Assurance',
        'Enhanced Data Security',
        'Enhanced Support',
      ],
      tooltips: [
        'Advanced configuration of Zoho Books includes basic zoho books setup and other default zoho books customizations like setting up portals, auto-responders, organization details and other similar features.',
        'Migration of essential non-financial data such as customers, vendors, and products/services.',
        'Transfer of core financial data like invoices, bills, and journal entries.',
        'Seamless transfer of complex inventory data, including stock levels, reorder points, and multi-location management.',
        'Handling and reconciliation of multi-currency transactions for global operations.',
        'Covers project handling so your ongoing engagements stay organized.',
        'Mapping of discounts, payments, and credits to the appropriate transactions.',
        'Migration of tax-related data including input/output taxes, agencies, and tax types.',
        'Accurate reconciliation of accounts, inventory, and balances for customers and vendors.',
        'Ensuring all migrated data matches the financial statements from QuickBooks.',
        'Robust security measures ensuring data integrity and confidentiality during migration.',
        'Three months of specialized post-migration assistance to address queries and ensure a seamless transition.',
      ]
    }
  ];
  
  return (
    <div className=" h-[80%] px-10 overflow-hidden bg-customWhite">
      <div className="flex flex-col md:flex-row justify-center items-stretch gap-6 py-10">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`w-full md:w-1/3 rounded-xl border border-red-100 p-6 ${
              index === 1 ? 'bg-customRed text-customWhite' : 'bg-customWhite text-black'
            } flex flex-col`}
          >
            <h2 className="text-[50px] mb-4">{plan.title}</h2>
            <hr className="my-4 h-[1.4px] bg-black" />
            <ul className="space-y-2 mb-4 flex-grow"> 
              {plan.features.map((feature, i) => (
                <li key={i} className="flex justify-between items-center">
                  <span className="flex my-[4px] items-center">
                    <span className="mr-2">⭐</span>
                    {feature}
                  </span>
                  <img
                    src={
                      index === 1
                        ? 'https://cdn.prod.website-files.com/65e7f17ed06050fdd972fa15/667d0c7608df6377a3b4a9bf_info%20(1).png'
                        : 'https://cdn.prod.website-files.com/65e7f17ed06050fdd972fa15/667d0580dba9301ca71609aa_info.png'
                    }
                    width={'15px'}
                    loading="lazy"
                    alt="info"
                    data-tooltip-id={`tooltip-${index}-${i}`}
                    data-tooltip-content={plan.tooltips[i]}
                  />
                  <Tooltip
                    id={`tooltip-${index}-${i}`}
                    place="top"
                    style={{
                      backgroundColor: '#FFFFFF',
                      zIndex: 9999,
                      color: '#333',
                      padding: '15px',
                      borderRadius: '5px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                      fontSize: '14px',
                      maxWidth: '250px',
                      textAlign: 'center',
                    }}
                  />
                </li>
              ))}
            </ul>
            <hr className="my-6 h-[1.4px] bg-black" />
            <div className="mb-4">
              <label className="block text-xl mb-4 font-medium">Transactions to be migrated for</label>
              <select
                value={formData[index].years}
                onChange={(e) => handleInputChange('years', e.target.value, index)}
                className="w-full p-2 text-black border rounded"
              >
                <option value={0}>Select Years</option>
                <option value={1}>1 Year + YTD</option>
                <option value={2}>2 Years + YTD</option>
                <option value={3}>3 Years + YTD</option>
                <option value={4}>4 Years + YTD</option>
                <option value={5}>5 Years + YTD</option>
                <option value={6}>6 Years + YTD</option>
                <option value={7}>7 Years + YTD</option>
                <option value={8}>8 Years + YTD</option>
                <option value={9}>9 Years + YTD</option>
                <option value={10}>10 Years + YTD</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-medium">Attachments to be migrated</label>
              <input
                type="number"
                min={0}
                value={formData[index].attachments}
                onChange={(e) => handleInputChange('attachments', e.target.value, index)}
                className="w-full text-black p-2 border rounded"
              />
            </div>
            <div className="mb-4">
              <p className="text-3xl font-semibold mb-6">Price: {prices[index].toFixed(2)}</p>
            </div>
            <button
              onClick={() => handleCheckoutButton(index)}
              className={`mt-6 w-full py-2 ${index === 1 ? 'text-black bg-customWhite' : 'text-customWhite bg-customRed'}`}
            >
              Buy Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
  
};

export default ZohoBooks;
